import { useState } from "react";
// Core Component
import MDCBanner from "../core/MDCBanner";
import MDCBannerDetailView from "../core/MDCBannerDetailView";
// Shared Component
import MessageDetailsDialog from "./MessageDetailsDialog";
// Constants
import {
  MessageDetailsDialogConstants,
  getSuccessMessageBanner,
} from "../../constants/PopupDialogConstants";
import { GLOBAL_MESSAGE_STATUS } from "../../constants/GlobalConstants";
// Material UI
import { makeStyles } from "@mui/styles";

// Styles
const useStyles = makeStyles(() => ({
  infoMsg: {
    width: "-webkit-fill-available",
    marginBottom: "2rem",
  },
  hashError: {
    fontWeight: "bold",
  },
  headerLabel: {
    marginBottom: "1rem",
  },
}));

const GlobalMessages = ({ globalMessages, showHeaderLabel = false }) => {
  const { infoMsg, hashError, headerLabel } = useStyles();
  const [displayMessagesModal, setDisplayMessagesModal] = useState(false);
  const [displayMessages, setDisplayMessages] = useState([]);
  const [showSuccessHeading, setShowSuccessHeading] = useState(false);
  const [status, setStatus] = useState("");

  const handleMessagesDetailButton = (status) => {
    let messages = [];
    if (status === GLOBAL_MESSAGE_STATUS.ERROR) {
      messages = globalMessages?.filter(
        (messageDetails) => messageDetails?.isError
      );
      setStatus(GLOBAL_MESSAGE_STATUS.ERROR);
    } else if (status === GLOBAL_MESSAGE_STATUS.INFO) {
      messages = globalMessages?.filter(
        (messageDetails) => messageDetails?.isError
      );
      setStatus(GLOBAL_MESSAGE_STATUS.INFO);
    } else if (status === GLOBAL_MESSAGE_STATUS.SUCCESS) {
      messages = globalMessages?.filter(
        (messageDetails) => !messageDetails?.isError
      );
      setStatus(GLOBAL_MESSAGE_STATUS.SUCCESS);
    }

    setDisplayMessagesModal(true);
    setDisplayMessages(messages);
    setShowSuccessHeading(
      status === GLOBAL_MESSAGE_STATUS.INFO ||
        status === GLOBAL_MESSAGE_STATUS.SUCCESS
    );
  };

  const getHashMessage = (hashMessageArray) => {
    return hashMessageArray.length > 0 ? hashMessageArray[0]?.message : "";
  };

  const getErrorMessage = (
    errorMessageArray,
    isHashMessagePresent,
    messageCount
  ) => {
    if (errorMessageArray.length === 0) {
      return "";
    } else {
      return `${
        isHashMessagePresent
          ? `${messageCount - 1} ${
              MessageDetailsDialogConstants.ERROR_DETAILS_WITH_HASH_STATEMENT
            }`
          : `${messageCount} ${MessageDetailsDialogConstants.ERROR_DETAILS_STATEMENT}`
      }`;
    }
  };

  const getErrorMessageView = () => {
    const errorMessageArray = globalMessages?.filter(
      (messageDetails) =>
        messageDetails?.isError && !messageDetails?.isHashMessage
    );

    const successMessageArray = globalMessages?.filter(
      (messageDetails) => !messageDetails?.isError
    );

    const hashErrorMessageArray = globalMessages?.filter(
      (messageDetails) =>
        messageDetails?.isError && messageDetails?.isHashMessage
    );

    const messageCount = globalMessages?.length - successMessageArray?.length;

    const isHashMessagePresent = hashErrorMessageArray?.length > 0;

    if (
      errorMessageArray?.length === 1 &&
      hashErrorMessageArray?.length === 0
    ) {
      return (
        <MDCBanner
          message={errorMessageArray[0]?.message}
          isIcon={
            successMessageArray.length > 0
              ? GLOBAL_MESSAGE_STATUS.INFO
              : GLOBAL_MESSAGE_STATUS.ERROR
          }
        />
      );
    } else if (
      hashErrorMessageArray?.length === 1 &&
      errorMessageArray?.length === 0
    ) {
      return (
        <MDCBanner
          message={hashErrorMessageArray[0]?.message}
          isIcon={
            successMessageArray.length > 0
              ? GLOBAL_MESSAGE_STATUS.INFO
              : GLOBAL_MESSAGE_STATUS.ERROR
          }
        />
      );
    } else if (errorMessageArray?.length || hashErrorMessageArray?.length) {
      return (
        <MDCBannerDetailView
          isIcon={
            successMessageArray.length > 0
              ? GLOBAL_MESSAGE_STATUS.INFO
              : GLOBAL_MESSAGE_STATUS.ERROR
          }
          handleMessagesDetailButton={() => {
            handleMessagesDetailButton(
              successMessageArray.length > 0
                ? GLOBAL_MESSAGE_STATUS.INFO
                : GLOBAL_MESSAGE_STATUS.ERROR
            );
          }}
        >
          <>
            {hashErrorMessageArray?.length > 0 && (
              <p className={hashError}>
                {getHashMessage(hashErrorMessageArray)}
              </p>
            )}
            {getErrorMessage(
              errorMessageArray,
              isHashMessagePresent,
              messageCount
            )}
          </>
        </MDCBannerDetailView>
      );
    }
  };

  const getSuccessHeaderMessage = (
    successMessageArray,
    isHashMessagePresent,
    messageCount
  ) => {
    if (successMessageArray.length === 0) {
      return "";
    } else {
      const totalMessageCount = isHashMessagePresent
        ? messageCount - 1
        : messageCount;
      return getSuccessMessageBanner(totalMessageCount);
    }
  };

  const getSuccessMessageView = () => {
    const errorMessageArray = globalMessages?.filter(
      (messageDetails) => messageDetails?.isError
    );

    const successMessageArray = globalMessages?.filter(
      (messageDetails) => !messageDetails?.isError
    );

    const hashSuccessMessageArray = globalMessages?.filter(
      (messageDetails) =>
        !messageDetails?.isError && messageDetails?.isHashMessage
    );

    const messageCount = globalMessages?.length - errorMessageArray?.length;

    const isHashMessagePresent = hashSuccessMessageArray?.length > 0;

    if (
      successMessageArray?.length === 1 &&
      hashSuccessMessageArray?.length === 0
    ) {
      return <MDCBanner message={successMessageArray[0]?.message} success />;
    } else if (
      hashSuccessMessageArray?.length === 1 &&
      successMessageArray?.length === 0
    ) {
      return (
        <MDCBanner message={hashSuccessMessageArray[0]?.message} success />
      );
    } else if (successMessageArray?.length || hashSuccessMessageArray?.length) {
      return (
        <MDCBannerDetailView
          success
          handleMessagesDetailButton={() => {
            handleMessagesDetailButton(GLOBAL_MESSAGE_STATUS.SUCCESS);
          }}
        >
          <>
            {hashSuccessMessageArray?.length > 0 && (
              <p className={hashError}>
                {getHashMessage(hashSuccessMessageArray)}
              </p>
            )}
            {getSuccessHeaderMessage(
              successMessageArray,
              isHashMessagePresent,
              messageCount
            )}
          </>
        </MDCBannerDetailView>
      );
    }
  };

  const getGlobalSuccessMessage = () => {
    return (
      <div className={infoMsg}>
        {/* Show Success Banner */}
        {getSuccessMessageView()}
        {/* Show Error Banner */}
        {getErrorMessageView()}
      </div>
    );
  };

  const handleErrorDetailsPopupClose = () => {
    setDisplayMessagesModal(false);
    setDisplayMessages([]);
    setShowSuccessHeading(false);
  };
  return (
    <>
      {/* Header label */}
      {showHeaderLabel ? (
        <label className={headerLabel}>
          Systemmeldungen aus dem vorherigen Vorgang.
        </label>
      ) : (
        <></>
      )}

      {/* Message Body */}
      {getGlobalSuccessMessage()}

      {/* Message Details Dialog/Popup */}
      {displayMessagesModal && (
        <MessageDetailsDialog
          popUpHeading={
            showSuccessHeading
              ? MessageDetailsDialogConstants.SUCCESS_DETAILS_POPUP_HEADING
              : MessageDetailsDialogConstants.ERROR_DETAILS_POPUP_HEADING
          }
          show={displayMessagesModal}
          handlePopupClose={handleErrorDetailsPopupClose}
          messages={displayMessages}
          status={status}
        />
      )}
    </>
  );
};

export default GlobalMessages;
